module.exports = __webpack_public_path__ + "static/media/circle-red.b8c57dc5.svg";